const COMPENSATION_AMOUNTS = {
    promo15: '15',
    promo20: '20',
    promo25: '25',
    promo30: '30',
    wifi: 'wifi'
};

export const GROUPS = {
    administrator: {
        name: 'administrator',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'audioINOP'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageLongWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageReturnAirport'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'conciergeDesk'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystemRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'customerRefusedTravel'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayOutCntrl'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPower'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'lastMinChange'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mapleLoungCapacity'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mishandledCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'misinformedCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'movedSeatA'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'movedSeatC'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenEconRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'noFirstCall'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'readingLight'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'seatIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenPremRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'seatUnclean'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealNotAvailable'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealShortage'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageUnderThree'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'serviceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTray'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'bagDamaged'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'terminalExperience'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'windowShade'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'customerServiceRecovery'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'damagedBag'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenEcon'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'scheduleChangeMajor'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'scheduleChangeNotice'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageGreaterThree'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageSEIssue'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'challengingFlightDisruption'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayCancellation'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayBusRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerBusRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerBus'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'multipleFailures'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'multiServiceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenPrem'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayBus'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistMedical'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistDisruptive'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'reissuedPromo'},
        ],
        key: ['08338fea-dc21-465a-843f-2a84257c2217']
    },
    airport: {
        name: 'airport',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayOutCntrl'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mishandledCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'serviceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'customerRefusedTravel'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'damagedBag'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'customerServiceRecovery'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayCancellation'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'challengingFlightDisruption'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['2f875c18-8646-41a4-940d-e7764422f04e']
    },
    baggage: {
        name: 'baggage',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageLongWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageReturnAirport'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageSEIssue'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'bagDamaged'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['8a6a157c-1d73-40eb-aaca-f36419bee3aa']
    },
    concierge: {
        name: 'concierge',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayOutCntrl'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mishandledCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealNotAvailable'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mapleLoungCapacity'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'conciergeDesk'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'terminalExperience'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'lastMinChange'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'serviceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'customerRefusedTravel'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'damagedBag'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'customerServiceRecovery'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayCancellation'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'challengingFlightDisruption'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['2683bdd4-4dc0-4e07-b433-04f19cf3a2c7']
    },
    contactCentre: {
        name: 'contactCentre',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'misinformedCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mishandledCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'noFirstCall'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'seatIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'scheduleChangeNotice'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'scheduleChangeMajor'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'multipleFailures'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'reissuedPromo'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['a9424460-46dc-4de5-a2be-3d7f7fc1ec8d']
    },
    inFlight: {
        name: 'inFlight',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'audioINOP'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPower'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'readingLight'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'windowShade'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTray'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealShortage'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageUnderThree'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'multiServiceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'movedSeatA'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'movedSeatC'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageGreaterThree'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenEcon'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'seatUnclean'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenPrem'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayBus'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerBus'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistMedical'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistDisruptive'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['060a324a-d5bb-4df3-a0d0-eaba88a7a4e8']
    },
    rouge: {
        ame: 'rouge',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'audioINOP'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystemRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'readingLight'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'windowShade'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealShortage'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageUnderThree'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenEconRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'seatUnclean'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'multiServiceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'seatBrokenPremRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'spillageGreaterThree'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'inSeatPowerBusRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'tableTrayBusRouge'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistMedical'},
            { amount: [COMPENSATION_AMOUNTS.promo30, COMPENSATION_AMOUNTS.wifi], scenario: 'assistDisruptive'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}
        ],
        key: ['b4bfc187-a222-4b39-bbef-7a3686d0c7be']
    },
    jazz: {
        name: 'jazz',
        compensations: [
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'accessibility'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mishandledCustomer'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'specialMealNotAvailable'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'mapleLoungCapacity'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayOutCntrl'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'conciergeDesk'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'terminalExperience'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'lastMinChange'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'serviceIssues'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'customerRefusedTravel'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageLongWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageReturnAirport'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'bagDamaged'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'customerServiceRecovery'},
            { amount: [COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.wifi], scenario: 'specialHandlingService'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'flightDelayCancellation'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'challengingFlightDisruption'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'baggageSEIssue'},
            { amount: [COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'wheelChairWait'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.wifi], scenario: 'inFlightSystem'},
            { amount: [COMPENSATION_AMOUNTS.promo15, COMPENSATION_AMOUNTS.promo20, COMPENSATION_AMOUNTS.promo25, COMPENSATION_AMOUNTS.wifi], scenario: 'other'}],
        key: ['54896979-1a70-4b88-b957-50fe1106ca90']
    },
    developer: {
        name: 'developer',
        key: ['b608d2f8-8c6e-41cb-856c-d2faa8b6e5bc']
    },
    qa: {
        name: 'qa',
        key: ['48c48a64-ade0-4b09-8c77-cc11fc209ae7']
    }
};

export const GROUP_IFS_ROLE = 'WiFiVoucher.Read.REL.Value';

export const GROUP_MAPPING = new Map();
GROUP_MAPPING.set(GROUPS.inFlight.key[0], {
    group: GROUPS.inFlight.name,
    compensations: GROUPS.inFlight.compensations
});
GROUP_MAPPING.set(GROUPS.inFlight.key[1], {
    group: GROUPS.inFlight.name,
    compensations: GROUPS.inFlight.compensations
});
GROUP_MAPPING.set(GROUPS.airport.key[0], {
    group: GROUPS.airport.name,
    compensations: GROUPS.airport.compensations
});
GROUP_MAPPING.set(GROUPS.baggage.key[0], {
    group: GROUPS.baggage.name,
    compensations: GROUPS.baggage.compensations
});
GROUP_MAPPING.set(GROUPS.concierge.key[0], {
    group: GROUPS.concierge.name,
    compensations: GROUPS.concierge.compensations
});
GROUP_MAPPING.set(GROUPS.contactCentre.key[0], {
    group: GROUPS.contactCentre.name,
    compensations: GROUPS.contactCentre.compensations
});
GROUP_MAPPING.set(GROUPS.administrator.key[0], {
    group: GROUPS.administrator.name,
    compensations: GROUPS.administrator.compensations
});
GROUP_MAPPING.set(GROUPS.developer.key[0], {
    group: GROUPS.developer.name,
    compensations: GROUPS.administrator.compensations
});
GROUP_MAPPING.set(GROUPS.qa.key[0], {
    group: GROUPS.qa.name,
    compensations: GROUPS.administrator.compensations
});
GROUP_MAPPING.set('08338fea-dc21-465a-843f-2a84257c2217', {
    group: GROUPS.administrator,
    compensations: GROUPS.administrator.compensations
});
GROUP_MAPPING.set(GROUPS.rouge.key[0], {
    group: GROUPS.rouge,
    compensations: GROUPS.rouge.compensations
});
GROUP_MAPPING.set(GROUPS.jazz.key[0], {
    group: GROUPS.jazz,
    compensations: GROUPS.jazz.compensations
});


export const getGroupFromRoles = (roles: string[]) => {
    if(roles.includes(GROUP_IFS_ROLE)){ 
        return GROUPS.inFlight.name;
    } else {
        return 'other';
    }
};

// Seat related category and cabin IDs
export const SEAT_RELATED_CATEGORY_IDS = {
    SEAT_DOES_NOT_RECLINE: '18d2b9ef-1f41-4ed3-82fa-3379ae4a1a43',
    SEAT_DEFLATED: '1b362a7d-fc6c-483f-94a5-c5904cecc7c3',
    TABLE_TRAY_BROKEN: '568f68b2-20cb-4b87-86e9-97c1a5feb931',
    FOOT_REST_BROKEN: '8283a2f0-df7e-42fb-821d-f8e5278a4559'
};

export const CABIN_IDS = {
    SIGNATURE_CLASS: 'ba72d4aa-b120-4a99-b228-be5bebdb7ad9'
};
